import { PoolName } from "@/shared/constants/pools";

export const arbitrumGoerliPools = [
  PoolName.WethUsdc,
  PoolName.ArbUsdc,
  PoolName.GmxUsdc,
] as const;
export const polygonPools = [PoolName.WethUsdc] as const;
export const arbitrumPools = [
  PoolName.WethUsdc,
  PoolName.ArbUsdc,
  PoolName.WethUsdce,
  PoolName.ArbUsdce,
  PoolName.WbtcWeth,
] as const;

export type ArbitrumActiveGoerliPools = (typeof arbitrumGoerliPools)[number];
export type ArbitrumActivePools = (typeof arbitrumPools)[number];
export type PolygonActivePools = (typeof polygonPools)[number];
